import { useMemo } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { CheckInPoliciesSectionComponentProps } from "./CheckInPoliciesSection";

export const useCheckInPolicies = ({
  checkInPolicies,
}: CheckInPoliciesSectionComponentProps) => {
  const { t } = useI18nContext();

  return useMemo(() => {
    return {
      context: {
        checkInPolicies,
      },
      handlers: {
        cleanPolicy: (policy: string) =>
          policy.split("\n").map((str) => str.trim()),
      },
      text: {
        title: t("core-hotels.shop.checkInPolicy.title"),
        readMore: t("core-hotels.shop.checkInPolicy.readMore"),
      },
    };
  }, [checkInPolicies, t]);
};
